import LogoIcon from "./LogoIcon";

export default function Logo() {
  return (
    <div className="flex flex-row items-center space-x-3">
      <LogoIcon />
      <span>bokahundtrim</span>
    </div>
  );
}
